import { render, staticRenderFns } from "./CoherenceEvaluation.vue?vue&type=template&id=2fe661c2&scoped=true"
import script from "./CoherenceEvaluation.vue?vue&type=script&lang=js"
export * from "./CoherenceEvaluation.vue?vue&type=script&lang=js"
import style0 from "./CoherenceEvaluation.vue?vue&type=style&index=0&id=2fe661c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe661c2",
  null
  
)

export default component.exports